'use client';

import React from 'react';
import CosaServiceLayout from '@/components/CosaServiceLayout';

const serviceData = {
  slug: 'medecine-specialisee',
  icon: 'fa-solid fa-heart-pulse',
  badge: 'Médecine Spécialisée',
  title: 'Médecine Spécialisée',
  subtitle: 'Expertise multidisciplinaire pour des diagnostics et traitements avancés',
  heroImage: '/assets/images/service_specialized_medicine.png',
  heroAlt: 'Médecin spécialiste africain en consultation avec équipement médical moderne à COSA',
  accentColor: '#0e5932',
  description: `La médecine spécialisée de COSA offre une expertise multidisciplinaire couvrant les principales spécialités médicales. Nos médecins spécialistes qualifiés et expérimentés assurent des diagnostics précis et des traitements avancés pour tous vos besoins de santé spécialisés.`,
  features: [
    { icon: 'fa-solid fa-baby', title: 'Pédiatrie', description: 'Soins complets pour les enfants, du nourrisson à l\'adolescent, incluant vaccinations et suivi de croissance.' },
    { icon: 'fa-solid fa-heart', title: 'Cardiologie', description: 'Diagnostic et traitement des maladies cardiovasculaires avec équipements modernes.' },
    { icon: 'fa-solid fa-eye', title: 'Ophtalmologie', description: 'Examens visuels complets, correction de la vue et traitement des pathologies oculaires.' },
    { icon: 'fa-solid fa-ear', title: 'ORL', description: 'Traitement des affections de l\'oreille, du nez et de la gorge.' },
    { icon: 'fa-solid fa-venus', title: 'Gynécologie', description: 'Suivi gynécologique, obstétrique et santé reproductive.' },
    { icon: 'fa-solid fa-skin', title: 'Dermatologie', description: 'Diagnostic et traitement des affections cutanées et dermatologiques.' },
  ],
  process: [
    { step: '01', title: 'Consultation Générale', description: 'Consultez d\'abord votre médecin généraliste pour une orientation spécialisée.' },
    { step: '02', title: 'Prise de Rendez-vous Spécialisé', description: 'Prenez rendez-vous avec le spécialiste approprié.' },
    { step: '03', title: 'Consultation Spécialisée', description: 'Examen approfondi et diagnostic par le médecin spécialiste.' },
    { step: '04', title: 'Plan de Traitement', description: 'Mise en place d\'un plan de traitement personnalisé et suivi régulier.' },
  ],
  stats: [
    { value: '6+', label: 'spécialités disponibles' },
    { value: '15+', label: 'médecins spécialistes' },
    { value: '24h', label: 'délai de rendez-vous' },
    { value: '70+', label: 'ans d\'expertise' },
  ],
};

export default function MedecineSpecialisee() {
  return <CosaServiceLayout service={serviceData} />;
}
